import {
  AmazonIcon
} from "./chunk-IY2A4BEN.mjs";
export {
  AmazonIcon
};
